import { SearchOutlined } from '@material-ui/icons'
import React, { Component } from 'react'
import './style.scss'
class Search extends Component {

  render() {
    return (
      <div className="search-component">
        <input type="text" />
        <SearchOutlined />
      </div>
    )
  }
}

export default Search